module.exports = __webpack_public_path__ + "static/media/Niveau_elN0_1_145075.7d8384e1.png";